import { NavbarStyleInterface } from "./nav_bar_style_interface";

export const navBarDefaultStyle: NavbarStyleInterface = {
    backgroundColor: "white",
    shadow: "shadow-light",
    paddingClasses: "px-3 py-2 sm:px-6",
    navigationIconColor: "black",
};
